/**
 * Simple function to upload invoice file(s) matching the provided CURL command
 * @param files - Single file or array of files to upload
 * @returns Promise with the API response
 */
export async function uploadInvoiceFiles(files: File | File[]) {
    try {
      // Convert single file to array for consistent handling
      const fileArray = Array.isArray(files) ? files : [files];
      
      // Create FormData matching the CURL command
      const formData = new FormData();
      fileArray.forEach(file => {
        formData.append('files', file);
      });
  
      // Headers matching the CURL command exactly
      const headers = {
        'Accept': 'application/json',
        'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
        'Cache-Control': 'no-cache',
        'Connection': 'keep-alive',
        'Origin': 'http://localhost:3000',
        'Pragma': 'no-cache',
        'Referer': 'http://localhost:3000/',
        'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36'
        // Note: Content-Type is automatically set by the browser for FormData
      };
  
      // Make the API call
      const response = await fetch('http://13.233.18.99:8052/api/v1/upload_invoices', {
        method: 'POST',
        headers: headers,
        body: formData
      });
  
      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
  
      // Return the JSON response
      const result = await response.json();
      return result;
  
    } catch (error: any) {
      console.error('Invoice upload failed:', error);
      throw new Error(`Upload failed: ${error.message}`);
    }
  }
  
  // Usage examples:
  // Single file: await uploadInvoiceFiles(singleFile);
  // Multiple files: await uploadInvoiceFiles([file1, file2, file3]);